export default "__VITE_ASSET__fmaai5nb__"